



















































































































































































































































import * as Util from '@/util.ts';
import * as Enums from '@/enums.ts';
import * as Constants from '@/constants.ts';
import Vue from 'vue';
import tm_Notification from '@/components/other/tm-notification.vue';
import { format } from 'date-fns';

export default Vue.extend({
  components: {
    'tm-notification': tm_Notification,
  },
  data() {
    return {
      showFeedbackModal: false,
      showQuestionModal: false,
      showSendMessageModal: false,
      showNotificationDetailsModal: false,
      eNotificationTypes: Enums.eNotificationTypes,
      eNotificationStatuses: Enums.eNotificationStatuses,
      notificationToShow: {} as TMNotification,
      currNotificationType: '',
      modalTitle: '',
      eNotificationDirection: Enums.eNotificationDirection,
      allRoutes: Constants.allRoutes,
    };
  },
  computed: {
    getPriviledgedNotificationMessage(): string {
      switch (this.$data.notificationToShow.type) {
        case Enums.eNotificationTypes.tablesideOrderAdd:
          return Util.t?.tablesideOrderAdd;
        case Enums.eNotificationTypes.tablesideOrderRemoval:
          return Util.t?.tablesideOrderRemoval;
        case Enums.eNotificationTypes.quantityLowered:
          return Util.t?.quantityLowered;
        case Enums.eNotificationTypes.quantityIncreased:
          return Util.t?.quantityIncreased;
      }
      return '';
    },
    currentLocation(): EstablishmentLocation {
      return this.$store.state.currentLocation;
    },
    wasReceived(): boolean {
      return this.$data.notificationToShow.direction === Enums.eNotificationDirection.received;
    },
    isTablesideMode(): boolean {
      return this.$store.state.appMode === Enums.eAppModes.tableside;
    },
    sentNotifications(): TMNotification[] {
      return this.$store.state.currentUserEstablishmentExchangeObject.notificationsToTheEstablishment.sort((a: TMNotification, b: TMNotification) => {
        return (b.dateCreated as number) - (a.dateCreated as number); // Sort notifications by date in descending fashion.
      });
    },
    receivedNotifications(): TMNotification[] {
      return this.$store.state.currentUserEstablishmentExchangeObject.notificationsToTheUser.sort((a: TMNotification, b: TMNotification) => {
        return (b.dateCreated as number) - (a.dateCreated as number); // Sort notifications by date in descending fashion.
      });
    },
    getExpectedWaitString(): string {
      return Util.t?.shouldBeReadyBy.supplant([format(new Date(this.$data.notificationToShow.dateCreated + this.$data.notificationToShow.expectedWait * 60 * 1000), 'h:mma')]);
    },
  },
  methods: {
    routerPush(args: any) {
      Util.routerPush(args);
    },
    formatCurrency(price: number): string {
      return Util.formatCurrency(price);
    },
    showNotificationDetails(notification: TMNotification) {
      this.$data.showNotificationDetailsModal = true;
      this.$data.notificationToShow = notification;
    },
    openSendMessageModal(msg: string, type: Enums.eNotificationTypes, focus: boolean = false) {
      Util.eventBus.$emit('closeModals');
      const notfier: any = this.$refs.notifier;
      if (focus) {
        Vue.nextTick(() => {
          notfier.focus();
        });
      }
      notfier.message = msg;
      this.$data.showSendMessageModal = true;
      this.$data.currNotificationType = type;
      switch (type) {
        case Enums.eNotificationTypes.request:
          this.$data.modalTitle = Util.t?.makeARequest;
          break;
        case Enums.eNotificationTypes.feedback:
          this.$data.modalTitle = Util.t?.giveFeedback;
          break;
        case Enums.eNotificationTypes.question:
          this.$data.modalTitle = Util.t?.askQuestion;
          break;
      }
    },
  },
});
